import { render } from "./ViewDemands.vue?vue&type=template&id=348c58e1&ts=true"
import script from "./ViewDemands.vue?vue&type=script&lang=ts"
export * from "./ViewDemands.vue?vue&type=script&lang=ts"

import "./ViewDemands.vue?vue&type=style&index=0&id=348c58e1&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__